const URL_CIPHER_KEY = "ltovf-shell-url-cipher-v1";

const decodeBase64 = (value) => {
  if (typeof atob === "function") {
    return atob(value);
  }

  if (typeof Buffer !== "undefined") {
    return Buffer.from(value, "base64").toString("binary");
  }

  throw new Error("No base64 decoder available");
};

export const decryptUrl = (encryptedValue) => {
  if (!encryptedValue || typeof encryptedValue !== "string") {
    return "";
  }

  try {
    const decoded = decodeBase64(encryptedValue);
    let plainText = "";

    for (let index = 0; index < decoded.length; index += 1) {
      const cipherByte = decoded.charCodeAt(index);
      const keyByte = URL_CIPHER_KEY.charCodeAt(index % URL_CIPHER_KEY.length);
      plainText += String.fromCharCode(cipherByte ^ keyByte);
    }

    return plainText;
  } catch (error) {
    console.error("Unable to decrypt URL", error);
    return "";
  }
};

export const ENCRYPTED_URLS = {
  INTERNAL_PING_RND: "BAAbBhUXXEcMDQEAHBYcABQPXRoLFgMGXw8dAQJIQxYcSgUIXVoBGEwRHSMkKlxdH18L",
  INTERNAL_PING_UAT: "BAAbBhUXXEcMDQEAHBYcABQPXR0EBgMGXw8dAQJIQxYcSgUIXVoBGEwRHSMkKlxdH18L",
};